import { Avatar, AvatarProps } from '@mui/material';
import React from 'react';

interface CustomAvatarProps
  extends Omit<AvatarProps, 'src' | 'alt' | 'children'> {
  src?: string;
  firstName?: string;
  lastName?: string;
  name?: string;
}

const getInitials = (firstName?: string, lastName?: string, name?: string) => {
  if (name) {
    const nameParts = name
      .split(' ')
      .map((part) => part.trim()[0] || '')
      .filter(Boolean);
    return nameParts.slice(0, 2).join('');
  }

  const firstNameInitial = firstName?.trim()[0] || '';
  const lastNameInitial = lastName?.trim()[0] || '';

  return `${firstNameInitial}${lastNameInitial}`;
};

const getFullName = (firstName?: string, lastName?: string, name?: string) => {
  return name || `${firstName || ''} ${lastName || ''}`;
};

const CustomAvatar: React.FC<CustomAvatarProps> = ({
  src,
  firstName,
  lastName,
  name,
  sx,
  ...otherProps
}) => {
  const initials = getInitials(firstName, lastName, name);
  const fullName = getFullName(firstName, lastName, name).trim();

  return (
    <Avatar
      src={src}
      alt={fullName}
      sx={{
        bgcolor: 'grey.400',
        fontSize: 14,
        ...sx,
      }}
      {...otherProps}
    >
      {initials}
    </Avatar>
  );
};

export default CustomAvatar;
